import { render } from "./IconMapPin.vue.js?vue&type=template&id=f65e5156!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./IconMapPin.vue?vue&type=template&id=f65e5156"
const script = {}

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__